export const isAndroid = (userAgent) => userAgent.match(/Android/i);

export const isIphone = (userAgent) => userAgent.match(/iPhone/i);



// WEBPACK FOOTER //
// ../q-components/helpers/userAgent.js